<template>
  <div class="content content-depotfinder">
    <div class="content__inner">
      <div class="wrapper">
        <BackButton @click="handleBack('/depotfinder')" />

        <NextArrowButton :nextStep="nextStep" />

        <Depositmodels />

        <div class="depotfinder__question text-centered">
          <UiHeadline
            tag="h1"
            size="large"
            theme="primary"
            align="center"
            class="depotfinder__headline"
          >
            {{ $t("depotfinder.age.headline") }}
          </UiHeadline>
          <p class="depotfinder__subline">
            {{ $t("depotfinder.age.subline") }}
          </p>

          <div class="radio-buttons">
            <div class="radio" v-for="(option, index) in options" :key="index">
              <input
                :id="'option-' + index"
                type="radio"
                name="radiogroup"
                :value="index"
                v-model="ageState"
              />
              <label :for="'option-' + index">
                <span v-html="$t('depotfinder.age.options.' + index)"></span>
                <span class="radio__checkmark"></span>
              </label>
            </div>
          </div>

          <NextButton :nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../../components/Ui/Headline.vue";
import Depositmodels from "./../../components/DepositModels.vue";
import BackButton from "./../../components/BackButton.vue";
import NextButton from "./../../components/NextButton.vue";
import NextArrowButton from "./../../components/NextArrowButton.vue";
import { backButtonMixin } from "./../../mixins/handleBackButton";

export default {
  mixins: [backButtonMixin],
  components: {
    Depositmodels,
    BackButton,
    NextButton,
    NextArrowButton,
    UiHeadline,
  },
  data() {
    return {
      options: this.$t("depotfinder.age.options"),
    };
  },
  computed: {
    recommendedDeposit() {
      return this.$store.getters.getRecommendedDeposit;
    },
    ageState: {
      get() {
        return this.$store.getters.getAgeState;
      },
      set(value) {
        this.$store.dispatch("updateAgeState", value);
      },
    },
    nextStep() {
      let nextStep = "";
      // User chose option "alone" in Step "Decision"
      if (this.$store.getters.getDecisionState == "alone") {
        // is older than 27
        if (this.$store.getters.getAgeState == "older") {
          nextStep = "depotfinder.orders";
          this.setRecommendedDeposit("");
          // is 27 or younger
        } else if (this.$store.getters.getAgeState == "younger") {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("DepotFuture");
        }
        // User chose any other options in Step "Decision"
      } else {
        // is older than 27
        if (this.$store.getters.getAgeState == "older") {
          nextStep = "depotfinder.assets";
          this.setRecommendedDeposit("");
          // is 27 or younger
        } else if (this.$store.getters.getAgeState == "younger") {
          nextStep = "depotfinder.results";
          this.setRecommendedDeposit("DepotFuture");
        }
      }
      return nextStep;
    },
  },
  methods: {
    setRecommendedDeposit(value) {
      this.$store.dispatch("updateRecommendedDeposit", value);
    },
    goToNextStep() {
      this.$router.push({ name: this.nextStep });
    },
  },
};
</script>
